import { IconDownload } from '@tabler/icons';
import { ConfigProvider, Modal, Pagination, Row, Table, Col } from 'antd';
import classNames from 'classnames/bind';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { FacebookIcon, FacebookShareButton } from 'react-share';
import styled from 'styled-components';
import packAPI from '~/api/PackAPI';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import EmptyForm from '~/components/Empty';
import CancelModal from '~/components/FormCancel';
import MyUseCardModal from '~/components/FormMyUseCard';
import { getNumberWithCommas } from '~/utils';
import CardAboutMe from '../../components/card-about-me';
import styles from './MyUseCard.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { useNavigate } from 'react-router';
import config from '~/config';

const cx = classNames.bind(styles);
const PaginationCustom = styled.div`
    .ant-pagination-options {
        display: none;
    }
`;

const MyUseCard = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const userInfo = useSelector((state) => state.user.userInfo);
    const [myUseCard, setMyUseCard] = useState([]);
    const [showMyUseCard, setShowMyUseCard] = useState(false);
    const [myHistoryUseCard, setMyHistoryUseCard] = useState(null);

    const [isShowQRCode, setIsShowQRCode] = useState(false);
    const [qrCodeZoom, setQRCodeZoom] = useState('');
    const [isShowShare, setIsShowShare] = useState(false);
    const [defaultExpandAllRows, setDefaultExpandAllRows] = useState(false);

    const [isShowAsk, setIsShowAsk] = useState(false);
    const [checkedStatus, setCheckedStatus] = useState(false);
    const [idUpdate, setIdUpdate] = useState('');
    const [textNoti, setTextNoti] = useState('');

    const [isCard, setIsCard] = useState(false);
    const [isUsedCard, setIsUsedCard] = useState(true);

    const onAgreeAsk = async () => {
        try {
            await packAPI.updateStatusConfirm(idUpdate, {
                is_confirm: checkedStatus,
            });
            handleGetMyUserCard(pagination.page);
        } catch (error) {}
        setIsShowAsk(false);
    };
    const onCancelAsk = () => {
        setIsShowAsk(false);
    };

    // const onChangeSwitchStatus = (checked, id) => {
    //     setIsShowAsk(true);
    // setTextNoti(checked ? 'Are you sure you have received the money' : 'Are you sure you have not received the money');
    //     setIdUpdate(id);
    //     setCheckedStatus(checked);
    // };

    const columns = [
        {
            title: () => {
                return <div className={cx('title_header')}>STT</div>;
            },
            render: (text, record, index) => <div>{(pagination.page - 1) * 10 + index + 1}</div>,
            align: 'center',
            dataIndex: 'STT',
            key: 'STT',
        },
        {
            title: () => {
                return <div className={cx('title_header')}>Tag User</div>;
            },
            render: (text, record, index) => (record?.user.fullname ? record?.user.fullname : record?.user.phone),
            align: 'center',
            dataIndex: 'fullname',
            key: 'fullname',
        },
        {
            title: () => {
                return <div className={cx('title_header')}>Value</div>;
            },
            render: (text, record, index) => <div>{getNumberWithCommas(record.value)} d</div>,
            align: 'center',
            dataIndex: 'value',
            key: 'value',
        },
        {
            title: () => {
                return <div className={cx('title_header')}>Last loaded</div>;
            },
            render: (item) => (
                <div
                    style={{
                        color: 'rgba(137, 137, 137, 1)',
                    }}
                >
                    {moment(item, 'x').format('HH:mm, DD/MM/YYYY')}
                </div>
            ),
            align: 'center',
            dataIndex: 'date_submit_pack_unix',
            key: 'date_submit_pack_unix',
        },
        {
            title: () => {
                return <div className={cx('title_header')}>Status</div>;
            },
            render: (text, record, index) => <div>Used</div>,
            align: 'center',
            dataIndex: 'status',
            key: 'status',
        },
    ];

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total_item: 0,
        total_page: 0,
    });

    const handleGetMyUserCard = async (page) => {
        try {
            setIsLoading(true);
            let cards = [];
            const params = {
                fields: '["$all"]',
                filter: `{"owner_id" : "${userInfo?.id}"}`,
                order: '[["created_at", "DESC"]]',
                limit: pagination.limit,
                page: page,
            };
            const res = await packAPI.getListPackAPI_UserUsing(userInfo?.id, params);

            if (res.code === 200) {
                cards = res.results.objects.map((item, index) => ({
                    key: index,
                    ...item,
                }));
                setPagination({
                    ...pagination,
                    page: page,
                    total_item: res.results.objects.count,
                    total_page: Math.ceil(res.results.objects.count / pagination.limit),
                });
            }
            setIsLoading(false);
            setMyUseCard(cards);
        } catch (err) {
            console.log(err);
        }
    };

    const handleChangePage = (page) => {
        setPagination({ ...pagination, page });
        handleGetMyUserCard(page);
        window.scrollTo(0, 0);
    };

    const handleSaveQRCode = (image) => {
        saveAs(image, `qr-code-booking-${moment().valueOf()}.png`);
    };

    const myUseCardDetail = (record) => {
        setShowMyUseCard(true);
        setMyHistoryUseCard(record);
        // navigate(config.routes.useCardDetail);
    };

    const onRejectRefillNow = () => {
        setShowMyUseCard(false);
    };

    useEffect(() => {
        handleGetMyUserCard(pagination.page);
    }, []);

    const mountRef = useRef(true);
    useEffect(() => {
        if (mountRef.current) {
            mountRef.current = false;
            return;
        }
        const script = document.createElement('script');

        script.src = 'https://sp.zalo.me/plugins/sdk.js';

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [isShowShare]);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangNguoiSuDungThe');
        // eslint-disable-next-line
    }, []);

    return (
        <>
            {/* PC UI */}
            <div className={cx('wrapper')}>
                <div className={cx('container')}>
                    <div className={cx('left_section')}>
                        <div className={cx('left_wrapper')}>
                            <div className={cx('left_container')}>
                                <Row>
                                    <CardAboutMe tabIndex={{ parent: 2, children: 1 }} />
                                </Row>
                            </div>
                        </div>
                    </div>
                    <div className={cx('right_section')}>
                        <Row className={cx('name_page')}>Tag User</Row>
                        <div className={cx('right_container')}>
                            {/* <div className={cx('table_container')}> */}
                            <Row>
                                <ConfigProvider renderEmpty={() => <EmptyForm />}>
                                    <Table
                                        className={cx('table')}
                                        columns={columns}
                                        onRow={(record, rowIndex) => {
                                            return {
                                                onClick: (event) => {
                                                    myUseCardDetail(record);
                                                }, // click row
                                            };
                                        }}
                                        // rowKey={record => record.user_id}
                                        // expandable={{
                                        //     expandedRowRender,
                                        //     // rowExpandable: (record) => expandRowMyUseCard(record),
                                        //     // onExpand: (expanded, record) => expandRowMyUseCard(expanded, record)
                                        // }}
                                        dataSource={myUseCard}
                                        pagination={false}
                                        loading={isLoading}
                                    />
                                </ConfigProvider>
                            </Row>
                            {myUseCard?.length ? (
                                <Row justify="center" style={{ marginTop: '30px' }}>
                                    <PaginationCustom>
                                        <Pagination
                                            defaultCurrent={1}
                                            current={pagination?.page}
                                            total={pagination?.total_item}
                                            pageSize={pagination?.limit}
                                            onChange={handleChangePage}
                                        />
                                    </PaginationCustom>
                                </Row>
                            ) : null}
                            {/* </div> */}
                        </div>
                    </div>
                </div>
                {isShowQRCode && (
                    <Modal
                        centered
                        title="QR Code"
                        visible={isShowQRCode}
                        onCancel={() => setIsShowQRCode(false)}
                        maskClosable={false}
                        footer={null}
                        width={500}
                        // className="otp-modal"
                    >
                        <div style={{ padding: '10px 10px' }}>
                            <img src={qrCodeZoom || IMAGES.ImagePlaceholder} alt="" className={cx('qr_code_zoom')} />
                        </div>
                    </Modal>
                )}
                {isShowShare && (
                    <Modal
                        centered
                        title="Share"
                        visible={isShowShare}
                        onCancel={() => setIsShowShare(false)}
                        maskClosable={false}
                        footer={null}
                        width={500}
                        // className="otp-modal"
                    >
                        <Row style={{ padding: '10px 10px' }}>
                            <img src={qrCodeZoom || IMAGES.ImagePlaceholder} alt="" className={cx('qr_code_zoom')} />
                        </Row>
                        <Row justify="center" align="middle">
                            <div
                                className="zalo-share-button"
                                data-href={qrCodeZoom}
                                data-oaid="579745863508352884"
                                data-layout="4"
                                data-color="blue"
                                data-share-type="2"
                                data-customize="true"
                            >
                                <div className={cx('share_zalo')}>
                                    <img src="https://stc.sp.zdn.vn/share/logo_white_s_2x_40.png" alt="zaloImg" />
                                </div>
                            </div>

                            <FacebookShareButton url={qrCodeZoom}>
                                <FacebookIcon size={52} className={cx('share_facebook')} />
                            </FacebookShareButton>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    color: 'black',
                                }}
                                onClick={() => handleSaveQRCode(qrCodeZoom)}
                            >
                                <IconDownload size={50} />
                            </div>
                        </Row>
                    </Modal>
                )}
                {isShowAsk && (
                    <Modal
                        centered
                        visible={isShowAsk}
                        onCancel={() => setIsShowAsk(false)}
                        maskClosable={false}
                        footer={null}
                        className="otp-modal"
                        width={500}
                    >
                        <div style={{ padding: '20px 20px' }}>
                            <CancelModal onAgreeCancel={onAgreeAsk} onRejectCancel={onCancelAsk} text={textNoti} />
                        </div>
                    </Modal>
                )}
                {showMyUseCard && (
                    <Modal
                        centered
                        visible={showMyUseCard}
                        onCancel={onRejectRefillNow}
                        maskClosable={false}
                        footer={null}
                        className="otp-modal"
                        width={700}
                    >
                        <div style={{ padding: '30px 10px 0px 10px' }}>
                            <MyUseCardModal
                                record={myHistoryUseCard}
                                // onAgreeRefillNow={onAgreeRefillNow}
                                // text="Are you sure you want to deposit money?"
                            />
                        </div>
                    </Modal>
                )}
            </div>

            {/* MB UI */}
            <div className={cx('wrapper_mb')}>
                <div className={cx('title_header')}>
                    <Row className={cx('header_row')}>
                        <Col>
                            <Row>
                                <img
                                    src={SVGS.ImageChevronLeft}
                                    alt="icon chevron left"
                                    className={cx('btn_search')}
                                    onClick={() => navigate(config.routes.personalPage)}
                                />
                                <span className={cx('header_title')}>My tags</span>
                            </Row>
                        </Col>
                    </Row>
                    <Row className={cx('header_row')}>
                        <Col>
                            <Row>
                                <span
                                    className={isCard ? cx('header_title_card_active') : cx('header_title_card')}
                                    onClick={() => {
                                        setIsCard(true);
                                        navigate(config.routes.card);
                                        setIsUsedCard(false);
                                    }}
                                >
                                    My cards
                                </span>
                            </Row>
                        </Col>
                        <Col>
                            <Row>
                                <span
                                    className={isUsedCard ? cx('header_title_card_active') : cx('header_title_card')}
                                    onClick={() => {
                                        setIsCard(false);
                                        setIsUsedCard(true);
                                    }}
                                >
                                    Card user
                                </span>
                            </Row>
                        </Col>
                    </Row>
                </div>
                {isUsedCard && (
                    <div className={cx('container_card')}>
                        {myUseCard.length > 0 ? (
                            myUseCard.map((item, index) => {
                                return (
                                    <Row key={index} className={cx('item_my_card')}>
                                        <Col
                                            onClick={() => {
                                                navigate({
                                                    pathname: config.routes.histotyUseCard,
                                                    search: `user_id=${item?.user_id}`,
                                                });
                                            }}
                                        >
                                            <Row>
                                                <p className={cx('item_my_card_name')}>
                                                    {item?.user?.fullname ? item?.user?.fullname : item?.user?.phone}
                                                </p>
                                            </Row>
                                            <Row>
                                                <p style={{ marginRight: '5px' }}>Last loaded: </p>
                                                <p>
                                                    {moment(+item?.date_submit_pack_unix, 'x').format(
                                                        'HH:mm DD/MM/YYYY',
                                                    )}
                                                </p>
                                            </Row>
                                        </Col>
                                        <Col
                                            onClick={() => {
                                                navigate({
                                                    pathname: config.routes.histotyUseCard,
                                                    search: `user_id=${item?.user_id}`,
                                                });
                                            }}
                                        >
                                            <img src={SVGS.ImageChevronRight} alt="" />
                                        </Col>
                                    </Row>
                                );
                            })
                        ) : (
                            <div className={cx('no_service')}>
                                <img src={SVGS.IconNoService} alt="" />
                                <span>No data!</span>
                            </div>
                        )}
                        {myUseCard?.length ? (
                            <Row justify="center" style={{ margin: '30px' }}>
                                <PaginationCustom>
                                    <Pagination
                                        defaultCurrent={1}
                                        current={pagination?.page}
                                        total={pagination?.total_item}
                                        pageSize={pagination?.limit}
                                        onChange={handleChangePage}
                                    />
                                </PaginationCustom>
                            </Row>
                        ) : null}
                    </div>
                )}
            </div>
        </>
    );
};

export default MyUseCard;
